import React from 'react';

import { css } from 'glamor';

export default function MobileOnly({ children }: { children: React.Element }) {
  return (
    <div
      {...css({
        display: 'block',
        '@media (min-width: 701px)': { display: 'none' },
      })}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ../src/client/components/layout/MobileOnly.js